/**
 * @flow
 * @relayHash ba57f32903f3aaf2ce5e66cbfce3fa47
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type JobLinkedItems_job$ref = any;
type JobsTable_jobEdges$ref = any;
export type JobStatus = "CLOSED" | "OPEN";
export type OrderStatus = "CONFIRMED" | "DELIVERED" | "IN_PRODUCTION" | "READY_FOR_SHIPMENT" | "SHIPPED" | "WAITING_FOR_CONFIRMATION" | "WAITING_FOR_PRODUCTION";
export type UOMType = "LENGTH" | "QUANTITY" | "WEIGHT";
export type UpdateJobLinkedItemInput = {|
  itemId: string,
  jobId: string,
  usageQty: number,
|};
export type UpdateJobLinkedItemMutationVariables = {|
  input: UpdateJobLinkedItemInput
|};
export type UpdateJobLinkedItemMutationResponse = {|
  +updateJobLinkedItem: {|
    +jobEdge: {|
      +node: {|
        +id: string,
        +importJobNumber: ?string,
        +jobNumber: string,
        +name: string,
        +status: JobStatus,
        +linkedItems: {|
          +edges: ?$ReadOnlyArray<?{|
            +usageQty: ?number,
            +node: {|
              +id: string,
              +itemNumber: string,
              +name: string,
              +upc: ?string,
              +partNumber: ?string,
              +description: ?string,
              +category: ?{|
                +id: string,
                +name: string,
              |},
              +quantityUOM: {|
                +id: string,
                +name: string,
                +type: UOMType,
                +symbol: string,
              |},
              +weightUOM: ?{|
                +id: string,
                +name: string,
                +type: UOMType,
                +symbol: string,
              |},
              +dimensionUOM: ?{|
                +id: string,
                +name: string,
                +type: UOMType,
                +symbol: string,
              |},
              +formFieldValues: any,
              +dimensionLength: ?number,
              +dimensionWidth: ?number,
              +dimensionHeight: ?number,
              +weight: ?number,
            |},
          |}>
        |},
        +yields: {|
          +totalCount: number,
          +edges: ?$ReadOnlyArray<?{|
            +node: {|
              +id: string,
              +finalQuantity: number,
            |}
          |}>,
        |},
        +user: ?{|
          +id: string,
          +firstName: string,
          +lastName: string,
        |},
        +order: ?{|
          +id: string,
          +promisedAt: ?any,
          +orderNumber: string,
          +status: OrderStatus,
          +customer: {|
            +id: string,
            +name: string,
          |},
        |},
        +workflow: {|
          +id: string,
          +name: string,
        |},
        +states: $ReadOnlyArray<{|
          +id: string,
          +workflowState: {|
            +id: string,
            +name: string,
          |},
        |}>,
        +$fragmentRefs: JobLinkedItems_job$ref,
      |},
      +$fragmentRefs: JobsTable_jobEdges$ref,
    |}
  |}
|};
export type UpdateJobLinkedItemMutation = {|
  variables: UpdateJobLinkedItemMutationVariables,
  response: UpdateJobLinkedItemMutationResponse,
|};
*/


/*
mutation UpdateJobLinkedItemMutation(
  $input: UpdateJobLinkedItemInput!
) {
  updateJobLinkedItem(input: $input) {
    jobEdge {
      ...JobsTable_jobEdges
      node {
        ...JobLinkedItems_job
        id
        importJobNumber
        jobNumber
        name
        status
        linkedItems {
          edges {
            usageQty
            node {
              id
              itemNumber
              name
              upc
              partNumber
              description
              category {
                id
                name
              }
              quantityUOM {
                id
                name
                type
                symbol
              }
              weightUOM {
                id
                name
                type
                symbol
              }
              dimensionUOM {
                id
                name
                type
                symbol
              }
              formFieldValues
              dimensionLength
              dimensionWidth
              dimensionHeight
              weight
            }
          }
        }
        yields {
          totalCount
          edges {
            node {
              id
              finalQuantity
            }
          }
        }
        user {
          id
          firstName
          lastName
        }
        order {
          id
          promisedAt
          orderNumber
          status
          customer {
            id
            name
          }
        }
        workflow {
          id
          name
        }
        states {
          id
          workflowState {
            id
            name
          }
        }
      }
    }
  }
}

fragment JobsTable_jobEdges on JobEdge {
  node {
    id
    jobNumber
    importJobNumber
    name
    status
    createdAt
    user {
      id
      ...UserAvatar_user
    }
    yields {
      totalCount
    }
    order {
      id
      promisedAt
      customer {
        id
        name
      }
    }
    states {
      id
      isEnabled
      status
      workflowState {
        id
        name
        type
      }
    }
    workflow {
      id
      states {
        id
        name
        isRequired
        type
      }
      transitions {
        id
        toWorkflowState {
          id
        }
        fromWorkflowState {
          id
        }
      }
    }
    ...AddUpdateJobModal_job
    ...DeleteJobModal_job
  }
}

fragment JobLinkedItems_job on Job {
  id
  ...AddJobLinkedItemModal_job
  ...AddUpdateJobLinkedItemModal_job
  linkedItems {
    edges {
      ...JobLinkedItemsTable_jobLinkedItemEdges
      node {
        id
        name
        partNumber
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment AddJobLinkedItemModal_job on Job {
  id
}

fragment AddUpdateJobLinkedItemModal_job on Job {
  id
  linkedItems {
    edges {
      usageQty
      node {
        id
        name
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment JobLinkedItemsTable_jobLinkedItemEdges on JobLinkedItemEdge {
  usageQty
  node {
    id
    itemNumber
    name
    partNumber
    description
    category {
      id
      name
    }
    quantityUOM {
      id
      symbol
    }
    ...DeleteJobLinkedItemModal_item
  }
}

fragment DeleteJobLinkedItemModal_item on Item {
  id
  name
}

fragment UserAvatar_user on User {
  id
  avatar
  firstName
}

fragment AddUpdateJobModal_job on Job {
  id
  name
  notes
  user {
    id
  }
  workflow {
    id
    name
    states {
      id
      isGangRun
    }
  }
  order {
    id
  }
  yields {
    edges {
      node {
        id
        quantity
        itemNumberUp
        brokerCustomerOrderNumber
        formFieldValues
        overUnderRule
        overQuantity
        item {
          id
          name
          quantityUOM {
            id
            name
            symbol
          }
        }
      }
    }
  }
}

fragment DeleteJobModal_job on Job {
  id
  name
  order {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateJobLinkedItemInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "importJobNumber",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "jobNumber",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "usageQty",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "itemNumber",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "upc",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "partNumber",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v12 = [
  (v2/*: any*/),
  (v5/*: any*/)
],
v13 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "category",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemCategory",
  "plural": false,
  "selections": (v12/*: any*/)
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "symbol",
  "args": null,
  "storageKey": null
},
v16 = [
  (v2/*: any*/),
  (v5/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/)
],
v17 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "weightUOM",
  "storageKey": null,
  "args": null,
  "concreteType": "UOM",
  "plural": false,
  "selections": (v16/*: any*/)
},
v18 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "dimensionUOM",
  "storageKey": null,
  "args": null,
  "concreteType": "UOM",
  "plural": false,
  "selections": (v16/*: any*/)
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "formFieldValues",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "dimensionLength",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "dimensionWidth",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "dimensionHeight",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "weight",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalCount",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "finalQuantity",
  "args": null,
  "storageKey": null
},
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstName",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastName",
  "args": null,
  "storageKey": null
},
v28 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "promisedAt",
  "args": null,
  "storageKey": null
},
v29 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "orderNumber",
  "args": null,
  "storageKey": null
},
v30 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "customer",
  "storageKey": null,
  "args": null,
  "concreteType": "Customer",
  "plural": false,
  "selections": (v12/*: any*/)
},
v31 = [
  (v2/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateJobLinkedItemMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateJobLinkedItem",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateJobLinkedItemPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "jobEdge",
            "storageKey": null,
            "args": null,
            "concreteType": "JobEdge",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Job",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "linkedItems",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "JobLinkedItemConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "JobLinkedItemEdge",
                        "plural": true,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Item",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v8/*: any*/),
                              (v5/*: any*/),
                              (v9/*: any*/),
                              (v10/*: any*/),
                              (v11/*: any*/),
                              (v13/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "quantityUOM",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "UOM",
                                "plural": false,
                                "selections": (v16/*: any*/)
                              },
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/),
                              (v23/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "yields",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "JobYieldConnection",
                    "plural": false,
                    "selections": [
                      (v24/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "JobYieldEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "JobYield",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v25/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v26/*: any*/),
                      (v27/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "order",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Order",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/),
                      (v6/*: any*/),
                      (v30/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "workflow",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Workflow",
                    "plural": false,
                    "selections": (v12/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "states",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "JobState",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "workflowState",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "WorkflowState",
                        "plural": false,
                        "selections": (v12/*: any*/)
                      }
                    ]
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "JobLinkedItems_job",
                    "args": null
                  }
                ]
              },
              {
                "kind": "FragmentSpread",
                "name": "JobsTable_jobEdges",
                "args": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateJobLinkedItemMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateJobLinkedItem",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateJobLinkedItemPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "jobEdge",
            "storageKey": null,
            "args": null,
            "concreteType": "JobEdge",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Job",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v3/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "createdAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "avatar",
                        "args": null,
                        "storageKey": null
                      },
                      (v26/*: any*/),
                      (v27/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "yields",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "JobYieldConnection",
                    "plural": false,
                    "selections": [
                      (v24/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "JobYieldEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "JobYield",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "quantity",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "itemNumberUp",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "brokerCustomerOrderNumber",
                                "args": null,
                                "storageKey": null
                              },
                              (v19/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "overUnderRule",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "overQuantity",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "item",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Item",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v5/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "quantityUOM",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "UOM",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v5/*: any*/),
                                      (v15/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v25/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "order",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Order",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v28/*: any*/),
                      (v30/*: any*/),
                      (v29/*: any*/),
                      (v6/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "states",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "JobState",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isEnabled",
                        "args": null,
                        "storageKey": null
                      },
                      (v6/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "workflowState",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "WorkflowState",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v5/*: any*/),
                          (v14/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "workflow",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Workflow",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "states",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "WorkflowState",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isGangRun",
                            "args": null,
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isRequired",
                            "args": null,
                            "storageKey": null
                          },
                          (v14/*: any*/)
                        ]
                      },
                      (v5/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "transitions",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "WorkflowTransition",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "toWorkflowState",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "WorkflowState",
                            "plural": false,
                            "selections": (v31/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "fromWorkflowState",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "WorkflowState",
                            "plural": false,
                            "selections": (v31/*: any*/)
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "notes",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "linkedItems",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "JobLinkedItemConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "JobLinkedItemEdge",
                        "plural": true,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Item",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v5/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "__typename",
                                "args": null,
                                "storageKey": null
                              },
                              (v8/*: any*/),
                              (v10/*: any*/),
                              (v11/*: any*/),
                              (v13/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "quantityUOM",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "UOM",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v15/*: any*/),
                                  (v5/*: any*/),
                                  (v14/*: any*/)
                                ]
                              },
                              (v9/*: any*/),
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/),
                              (v23/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "cursor",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "pageInfo",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "endCursor",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "hasNextPage",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedHandle",
                    "alias": null,
                    "name": "linkedItems",
                    "args": null,
                    "handle": "connection",
                    "key": "Job_linkedItems",
                    "filters": []
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateJobLinkedItemMutation",
    "id": null,
    "text": "mutation UpdateJobLinkedItemMutation(\n  $input: UpdateJobLinkedItemInput!\n) {\n  updateJobLinkedItem(input: $input) {\n    jobEdge {\n      ...JobsTable_jobEdges\n      node {\n        ...JobLinkedItems_job\n        id\n        importJobNumber\n        jobNumber\n        name\n        status\n        linkedItems {\n          edges {\n            usageQty\n            node {\n              id\n              itemNumber\n              name\n              upc\n              partNumber\n              description\n              category {\n                id\n                name\n              }\n              quantityUOM {\n                id\n                name\n                type\n                symbol\n              }\n              weightUOM {\n                id\n                name\n                type\n                symbol\n              }\n              dimensionUOM {\n                id\n                name\n                type\n                symbol\n              }\n              formFieldValues\n              dimensionLength\n              dimensionWidth\n              dimensionHeight\n              weight\n            }\n          }\n        }\n        yields {\n          totalCount\n          edges {\n            node {\n              id\n              finalQuantity\n            }\n          }\n        }\n        user {\n          id\n          firstName\n          lastName\n        }\n        order {\n          id\n          promisedAt\n          orderNumber\n          status\n          customer {\n            id\n            name\n          }\n        }\n        workflow {\n          id\n          name\n        }\n        states {\n          id\n          workflowState {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment JobsTable_jobEdges on JobEdge {\n  node {\n    id\n    jobNumber\n    importJobNumber\n    name\n    status\n    createdAt\n    user {\n      id\n      ...UserAvatar_user\n    }\n    yields {\n      totalCount\n    }\n    order {\n      id\n      promisedAt\n      customer {\n        id\n        name\n      }\n    }\n    states {\n      id\n      isEnabled\n      status\n      workflowState {\n        id\n        name\n        type\n      }\n    }\n    workflow {\n      id\n      states {\n        id\n        name\n        isRequired\n        type\n      }\n      transitions {\n        id\n        toWorkflowState {\n          id\n        }\n        fromWorkflowState {\n          id\n        }\n      }\n    }\n    ...AddUpdateJobModal_job\n    ...DeleteJobModal_job\n  }\n}\n\nfragment JobLinkedItems_job on Job {\n  id\n  ...AddJobLinkedItemModal_job\n  ...AddUpdateJobLinkedItemModal_job\n  linkedItems {\n    edges {\n      ...JobLinkedItemsTable_jobLinkedItemEdges\n      node {\n        id\n        name\n        partNumber\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment AddJobLinkedItemModal_job on Job {\n  id\n}\n\nfragment AddUpdateJobLinkedItemModal_job on Job {\n  id\n  linkedItems {\n    edges {\n      usageQty\n      node {\n        id\n        name\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment JobLinkedItemsTable_jobLinkedItemEdges on JobLinkedItemEdge {\n  usageQty\n  node {\n    id\n    itemNumber\n    name\n    partNumber\n    description\n    category {\n      id\n      name\n    }\n    quantityUOM {\n      id\n      symbol\n    }\n    ...DeleteJobLinkedItemModal_item\n  }\n}\n\nfragment DeleteJobLinkedItemModal_item on Item {\n  id\n  name\n}\n\nfragment UserAvatar_user on User {\n  id\n  avatar\n  firstName\n}\n\nfragment AddUpdateJobModal_job on Job {\n  id\n  name\n  notes\n  user {\n    id\n  }\n  workflow {\n    id\n    name\n    states {\n      id\n      isGangRun\n    }\n  }\n  order {\n    id\n  }\n  yields {\n    edges {\n      node {\n        id\n        quantity\n        itemNumberUp\n        brokerCustomerOrderNumber\n        formFieldValues\n        overUnderRule\n        overQuantity\n        item {\n          id\n          name\n          quantityUOM {\n            id\n            name\n            symbol\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment DeleteJobModal_job on Job {\n  id\n  name\n  order {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a3b5aa239c01b917a826512219718f39';
module.exports = node;
